exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-custom[data-v-1d6befa1]{border-radius:2rem}", ""]);

// exports
